module.exports = __webpack_public_path__ + "aa31ee0af98d08407676d980e22a5012.svg";